import { render, staticRenderFns } from "./AssignSubCatalogDropdown.vue?vue&type=template&id=8d7d759a&scoped=true"
import script from "./AssignSubCatalogDropdown.vue?vue&type=script&lang=js"
export * from "./AssignSubCatalogDropdown.vue?vue&type=script&lang=js"
import style0 from "./AssignSubCatalogDropdown.vue?vue&type=style&index=0&id=8d7d759a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7d759a",
  null
  
)

export default component.exports